(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1055],{

/***/ 836:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(1193);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 1193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Blogs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1746);
/* harmony import */ var _styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6240);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);







var __N_SSG = true;
function Blogs(param) {
    let { Allblogs  } = param;
    const [isSSR, setIsSSR] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsSSR(false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "The Twin Towers Hotel in Kufri, Shimla Blog - Insights, Tips, and Travel blog"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Click on the link and read blogs about The Twin Towers Hotel, discover its activities, and learn more about the surrounding area."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/blogs"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                bgImage: "/images/contact-banner.png",
                title: "Our Blogs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blogs), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_bottom), " "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "d-none",
                                children: "The twin Towers Hotel Blogs"
                            }),
                            Allblogs.slice(0, 1).map((blog)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/blogs/".concat(blog.slug),
                                    className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().top_blog)),
                                    children: !isSSR && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().top_blog_image),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                    src: blog.bgImage,
                                                    fill: true,
                                                    alt: blog.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().top_blog_content), " d-flex"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: (_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_date),
                                                            children: blog.date
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                            className: (_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_title),
                                                            children: blog.blog_title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: blog.shortDescription
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "common_btn",
                                                            children: "Read More"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }, blog.slug)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().all_blogs), " common_padding"),
                                children: Allblogs.slice(1).map((blog)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/blogs/".concat(blog.slug),
                                        className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().single_blog_parent)),
                                        children: !isSSR && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().all_blog_image),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                        src: blog.bgImage,
                                                        fill: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat((_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().all_blog_content), " d-flex"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: (_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_date),
                                                                children: blog.date
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                className: (_styles_pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_title),
                                                                children: blog.blog_title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: blog.shortDescription
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }, blog.slug))
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 1746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"single_blog_top_banner":"Blogs_single_blog_top_banner__BJmMQ","blogs":"Blogs_blogs__GHMzO","blog_top":"Blogs_blog_top__PnvhB","blog_top_img":"Blogs_blog_top_img__TEEWY","top_blog":"Blogs_top_blog__9s2wT","top_blog_image":"Blogs_top_blog_image__nwOQH","top_blog_content":"Blogs_top_blog_content___5dOg","all_blogs":"Blogs_all_blogs___z2VY","single_blog_parent":"Blogs_single_blog_parent__X_OP1","all_blog_image":"Blogs_all_blog_image__KwBr1","all_blog_content":"Blogs_all_blog_content__KaN21","blog_title":"Blogs_blog_title__2VT8r","blog_date":"Blogs_blog_date__mRo7f","single_blog":"Blogs_single_blog__2FkBD","single_blog_page_top":"Blogs_single_blog_page_top__Zkl9V","blog_social_links_parent":"Blogs_blog_social_links_parent__K_mXU","single_blog_destinations_btn":"Blogs_single_blog_destinations_btn__BB8yM","blog_page_social_links":"Blogs_blog_page_social_links__sCEer","link_icon":"Blogs_link_icon__TC7OZ","highlight_div":"Blogs_highlight_div__V92fw","h5_text":"Blogs_h5_text__rRZaB","images_sec":"Blogs_images_sec__hT6t6","blog_text1":"Blogs_blog_text1__weznr","recent_blog_sec":"Blogs_recent_blog_sec__38kjm","sticky_recent_posts":"Blogs_sticky_recent_posts__L_Xut","recent_top":"Blogs_recent_top__PYyfD","recent_bottom":"Blogs_recent_bottom__yhmBO","recent_bottom_main":"Blogs_recent_bottom_main__97XiQ","recent_bottom_right":"Blogs_recent_bottom_right__cCZsO","recent_blog_bottom_img_sec":"Blogs_recent_blog_bottom_img_sec__CpL5_","recent_blog_bottom_img":"Blogs_recent_blog_bottom_img__qSRIP","recent_blog_bottom_img_content":"Blogs_recent_blog_bottom_img_content__DE6hF","blog_footer":"Blogs_blog_footer__Zg8ce","blog_footer_content":"Blogs_blog_footer_content__p_bgS","blogs_sec":"Blogs_blogs_sec__qXez2","blogs_child":"Blogs_blogs_child__mB5qG","blog_child_image":"Blogs_blog_child_image__qUe27","blog_bottom":"Blogs_blog_bottom__8tl1F","read_more_btn":"Blogs_read_more_btn__6zQrg","button_sec":"Blogs_button_sec__y__xN","blog_page_btn":"Blogs_blog_page_btn__m1YUa"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(836); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);